const DownloadSmall = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fifillRulele="evenodd" clipRule="evenodd" d="M9.167 11.321 5.59 7.744 4.41 8.922l5.59 5.59 5.589-5.59-1.179-1.178-3.577 3.577V.833H9.167v10.488zm10 6.179H.834v-4.167h1.667v2.5h15v-2.5h1.666V17.5z" fill="#000" />
    </svg>
)
export default DownloadSmall;